import { Item } from './types'

export const itemFromtask = (
  task: Task,
  disabledTaskIds: Set<number>,
  selectedTaskIds: Set<number>,
  { hideActive } = { hideActive: true },
): Item => ({
  active: hideActive ? undefined : task.active,
  task,
  disabled: disabledTaskIds.has(task.id) && selectedTaskIds.has(task.id),
  checked: selectedTaskIds.has(task.id),
})

export const itemsFromTasks = (
  tasks: Task[],
  disabledTaskIds: Set<number>,
  selectedTaskIds: Set<number>,
  { hideActive } = { hideActive: true },
): Item[] => {
  return tasks.map((task) =>
    itemFromtask(task, disabledTaskIds, selectedTaskIds, { hideActive }),
  )
}

export const includes = (search: string) => (string: string | null) => {
  return string?.toLowerCase()?.includes(search)
}

export const findItem = (items: Item[], taskId: number) => {
  const item = items.find(({ task }) => task.id === taskId)

  if (!item) throw new Error(`Unreachable: Task with id ${taskId} not found`)

  return item
}
